import { ifNotAuthenticated } from "@/utils/functions";

import MedicalRequirementsPlansTests from "@/views/historicalPlans/medicalRequirementsPlansTests/MedicalRequirementsPlansTests.vue";
import MedicalRequirementsPlanTestsAdd from "@/views/historicalPlans/medicalRequirementsPlansTests/MedicalRequirementsPlanTestsAdd.vue";
import MedicalRequirementsPlanTestsEdit from "@/views/historicalPlans/medicalRequirementsPlansTests/MedicalRequirementsPlanTestsEdit.vue";

const Routes = [
  {
    path: "medical-requirements-plans-tests",
    name: "MedicalRequirementsPlansTests",
    component: MedicalRequirementsPlansTests,
    beforeEnter: ifNotAuthenticated,
    props(route) {
      return route.params || {};
    },
  },
  {
    path: "add-medical-requirements-plan-tests",
    name: "MedicalRequirementsPlanTestsAdd",
    component: MedicalRequirementsPlanTestsAdd,
    beforeEnter: ifNotAuthenticated,
    props(route) {
      return route.params || {};
    },
  },
  {
    path: "edit-medical-requirements-plan-tests",
    name: "MedicalRequirementsPlanTestsEdit",
    component: MedicalRequirementsPlanTestsEdit,
    beforeEnter: ifNotAuthenticated,
    props(route) {
      return route.params || {};
    },
  },
];

export default Routes;
